import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveItemFromListMutationVariables = Types.Exact<{
  input: Types.DeleteListItemInput;
}>;

export type RemoveItemFromListMutation = {
  __typename?: 'Mutation';
  deleteListItem: boolean;
};

export const RemoveItemFromListDocument = gql`
  mutation RemoveItemFromList($input: DeleteListItemInput!) {
    deleteListItem(input: $input)
  }
`;
export type RemoveItemFromListMutationFn = Apollo.MutationFunction<
  RemoveItemFromListMutation,
  RemoveItemFromListMutationVariables
>;

/**
 * __useRemoveItemFromListMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromListMutation, { data, loading, error }] = useRemoveItemFromListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveItemFromListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveItemFromListMutation,
    RemoveItemFromListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveItemFromListMutation,
    RemoveItemFromListMutationVariables
  >(RemoveItemFromListDocument, options);
}
export type RemoveItemFromListMutationHookResult = ReturnType<
  typeof useRemoveItemFromListMutation
>;
export type RemoveItemFromListMutationResult =
  Apollo.MutationResult<RemoveItemFromListMutation>;
export type RemoveItemFromListMutationOptions = Apollo.BaseMutationOptions<
  RemoveItemFromListMutation,
  RemoveItemFromListMutationVariables
>;
